module.exports = __webpack_public_path__ + "c1d5cf2e2d13b4dbb854d6e136cbbf7c.svg";